import { render, staticRenderFns } from "./ACardWithHeader.vue?vue&type=template&id=5d9f6432&scoped=true&"
import script from "./ACardWithHeader.vue?vue&type=script&lang=ts&"
export * from "./ACardWithHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ACardWithHeader.vue?vue&type=style&index=0&id=5d9f6432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f6432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
